'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import LandCategorySelectController from "./controller/landCategorySelect";
import LandCategoriesController from "./controller/landCategories";
import LandCategoryModalCreateController from "./controller/landCategoryModalCreate";
import LandCategoryTableDirective from "./directive/landCategoryTable";
// import LandCategorySelectDirective from "./directive/landCategorySelect";
import LandCategoryService from "./service/landCategory";

export default angular.module('investmentProject.landCategory', [])
    .controller('LandCategorySelectController', LandCategorySelectController)
    .controller('LandCategoriesController', LandCategoriesController)
    .controller('LandCategoryModalCreateController', LandCategoryModalCreateController)
    .directive('landCategoryTable', LandCategoryTableDirective)
    .factory('LandCategoryService', LandCategoryService)
    .name;